module.exports = __webpack_public_path__ + "img/xmasParty10.b5f650e0.jpg";